import { Auth } from 'aws-amplify';
import config from 'aws-exports';
import { Mutex } from 'async-mutex';
import { validateUploadFileName } from './fileUploadValidation';
import { invokeLambdaWithRetry, invokeLambda, invokeLambdaWithAPI } from "./Helper";
import { userTracer } from "../logging";
import { createUiLogger } from "../logging/uiLogger";
const console = createUiLogger("meaplatform/services/Utils.js");


let clientLock = new Mutex();

var paramsLoaded;
var paramsLoadedTs;

function isCacheValid() {
    if (paramsLoadedTs === undefined) {
        return false;
    }
    const now = new Date();
    const msBetweenDates = Math.abs(paramsLoadedTs.getTime() - now.getTime());
    const secBetweenDates = msBetweenDates / 1000;
    if (secBetweenDates > 300) {
        return false;
    }
    return true;
}

export async function getParameterFromManager(paramName, traceMeta = {}) {
    const backend = config.aws_user_files_s3_bucket.split('-');
    const env = backend[backend.length - 1];
    const {
        forceRefresh = false,
        impactKind,
        impactReason,
        data: traceData = {},
        ...traceOverrides
    } = traceMeta || {};
    const trace = userTracer.startOperation("ssm.resolve-parameter", {
        module: "services",
        screen: typeof window !== "undefined" ? window.location.pathname : "/",
        impactKind: impactKind || "user-visible",
        impactReason:
            impactReason || "Config lookup is happening as part of the active browser flow.",
        data: {
            paramName,
            backend: env,
            ...traceData
        },
        ...traceOverrides
    });
    let refreshedCache = false;
    try {
        if (forceRefresh || !paramsLoaded || paramsLoaded?.length === 0 || !isCacheValid()) {
            const release = await clientLock.acquire();
            let paramsLoadedResp = null;
            try {
                // If another instance is already fetching parameters, wait for it
                if (forceRefresh || !paramsLoaded || paramsLoaded?.length === 0 || !isCacheValid()) {
                    paramsLoadedResp = await invokeGetParameterFromManager(paramName, { bypassCache: forceRefresh === true });
                    if (Array.isArray(paramsLoadedResp?.cachedData)) {
                        paramsLoaded = paramsLoadedResp.cachedData;
                        paramsLoadedTs = new Date(); // Update timestamp
                        refreshedCache = true;
                    }
                }
            } finally {
                release(); // Ensure the lock is released
            }
        }
        var existParam = paramsLoaded?.filter(obj => {
            return obj.Name === `${paramName}-${env}`;
        });
        if (existParam !== undefined && existParam.length > 0) {
            trace.finish({
                data: {
                    paramName,
                    backend: env,
                    found: true,
                    refreshedCache,
                    cacheHit: !refreshedCache
                }
            });
            return existParam[0].Value;

        } else {
            existParam = paramsLoaded?.filter(obj => {
                return obj.Name === `${paramName}`;
            });
            if (existParam !== undefined && existParam.length > 0) {
                trace.finish({
                    data: {
                        paramName,
                        backend: env,
                        found: true,
                        refreshedCache,
                        cacheHit: !refreshedCache,
                        fallbackName: paramName
                    }
                });
                return existParam[0].Value;
            }
        }
        trace.finish({
            data: {
                paramName,
                backend: env,
                found: false,
                refreshedCache,
                cacheHit: !refreshedCache
            }
        });
        return null;
    } catch (error) {
        trace.fail(error, {
            data: {
                paramName,
                backend: env,
                refreshedCache
            }
        });
        throw error;
    }
}

export async function updateParameterInManager(paramName, newValue) {
    var backend = config.aws_user_files_s3_bucket.split('-');
    var env = backend[backend.length - 1];
    if (paramsLoaded === undefined)
        return;
    var existParam = paramsLoaded.filter(obj => {
        return obj.Name === `${paramName}-${env}`;
    });
    if (existParam !== undefined && existParam.length > 0) {
        existParam[0].Value = newValue;
        return;
    } else {
        existParam = paramsLoaded.filter(obj => {
            return obj.Name === `${paramName}`;
        });
        if (existParam !== undefined && existParam.length > 0) {
            existParam[0].Value = newValue;
            return;
        }
    }
    return null;
}

export async function invokeGetParameterFromManager(paramName, options = {}) {
    // The second argument is either a template name or { bypassCache, templateName }.
    const { bypassCache = false, templateName } = typeof options === 'string' ? { templateName: options } : (options || {});
    try {
        const session = await Auth.currentSession();
        const body = {
            access_token: session.getIdToken().getJwtToken(),
            target: "getValueFromSSM",
            isFrontendRequest: !templateName,
            ...(bypassCache ? { bypassCache: true } : {}),
            paramName,
            ...(templateName ? { templateName } : {})
        };
        const init = {
            body: JSON.stringify(body),
        };

        let result;
        console.debug(`import.meta.env?.VITE_DEFAULT_INVOCATION : ${import.meta.env?.VITE_DEFAULT_INVOCATION}`);
        if (import.meta.env?.VITE_DEFAULT_INVOCATION === "api") {
            result = await invokeLambdaWithAPI("instanceHandler", init, "POST", true);
        } else {
            result = await invokeLambdaWithRetry("instanceHandler", init, undefined, undefined, true);
        }
        return result?.response;
    } catch (err) {
        console.error("err: ", err);
        return false;
    }
}

export function validateFileName(fileName, config = {}) {
  return validateUploadFileName(fileName, config);
}
